import { render, staticRenderFns } from "./AturStruk.vue?vue&type=template&id=4b2ec6c7"
import script from "./AturStruk.vue?vue&type=script&lang=js"
export * from "./AturStruk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports